import { match } from 'path-to-regexp';

export function getRoutePathParams(pattern: string, url: string) {
  const matcher = match<Record<string, string>>(pattern, { decode: decodeURIComponent });
  const matched = matcher(url);

  if (matched) return matched.params;
  return {};
}
